/** Shared frontend configuration. */

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Resolve an asset path returned by the API. Backend-served assets (e.g. generated
 * feed logos at /api/logos/...) need the backend origin when the frontend and API
 * are on different hosts; absolute URLs and other paths pass through unchanged.
 */
export const assetUrl = (path) =>
  path && path.startsWith('/api/') ? `${BACKEND_URL}${path}` : path;
